import booking from './booking/fr'
const en = {
  common: {
    all: 'Tous',
    username: 'Username',
    password: 'Password',
    search: 'Search',
    continue: 'Continue',
    ok: 'OK',
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
    move: 'Move',
    restore: 'Restore',
    addMenu: 'Create new menu',
    addContent: 'Add to menu',
    addToSubmenu: 'Add to submenu',
    addSubmenu: 'Create submenu',
    delete: 'Delete',
    language: 'Language',
    struct: 'Struct',
    selectImage: 'Select image',
    height: 'Height',
    url: 'URL',
    text: 'Text',
    back: 'Go back',
    send: 'Send',

    collapse: 'Collapse',
    expand: 'Expand',

    today: 'Aujourd’hui',
    tomorrow: 'Demain',
    m0: 'Janvier',
    m1: 'Février',
    m2: 'Mars',
    m3: 'Avril',
    m4: 'Mai',
    m5: 'Juin',
    m6: 'Juillet',
    m7: 'Août',
    m8: 'Septembre',
    m9: 'Octobre',
    m10: 'Novembre',
    m11: 'Décembre',
    s0: 'Lundi',
    s1: 'Mardi',
    s2: 'Mercredi',
    s3: 'Jeudi',
    s4: 'Vendredi',
    s5: 'Samedi',
    s6: 'Dimanche',
    s0Small: 'Lun',
    s1Small: 'Mar',
    s2Small: 'Mer',
    s3Small: 'Jeu',
    s4Small: 'Ven',
    s5Small: 'Sam',
    s6Small: 'Dim',

    addToCalendar: 'Add to calendar',

    error2mb: 'The image cannot exceed 2MB',

    selectMenu: 'Select the menu to move the content',

    addressToSearch: 'Address',

    totemMenuImportant: 'TOTEM - Important menu',
    totemMenuImportantImage: 'TOTEM - Background menu',

    dayOfWeekSmall: {
      0: 'Su',
      1: 'Mo',
      2: 'Tu',
      3: 'We',
      4: 'Th',
      5: 'Fr',
      6: 'Sa'
    },
    dayOfWeek: {
      0: 'Sunday',
      1: 'Monday',
      2: 'Tuesday',
      3: 'Wednesday',
      4: 'Thursday',
      5: 'Friday',
      6: 'Saturday'
    },
    required: 'The fields are required',
    pleaseStandBy: 'Please stand by'
  },
  login: {
    title: 'Login form',
    login: 'login',
    messages: {
      required: 'Username and password are required',
      userNotFound: 'The username or password is incorrect',
      moveContent: 'Move content',
      cloneMenu: 'Clone menu'
    }
  },
  dashboard: {
    title: 'Dashboard',
    changePassword: 'Change password',
    logout: 'Logout',
    webs: 'Web App',
    welcome: 'Welcome',
    lastModification: 'Last modification',
    cloneEnterprise: 'Clone',
    content: 'Content',
    logs: {
      title: 'Logs',
      username: 'User',
      action: 'Action',
      menuname: 'Menu',
      lmd: 'Date',
      actions: {
        deleted: 'Delete',
        update: 'Update',
        sort: 'Sort'
      }
    },
    stats: {
      access: 'Access Web App ',
      accessMenu: 'Accesos menu ',
      month: 'Month',
      day: 'Day',
      menu: 'Menu',
      clicks: 'Clicks'
    }
  },
  changePassword: {
    oldPassword: 'Old password',
    password: 'New password',
    repeatPassword: 'Repeat password',
    messages: {
      oldPasswordRequired: 'The previous password is required',
      passwordRequired: 'Password is required',
      sameAsPassword: 'Passwords must match',
      UserNotFound: 'Username or password does not match',
      success: 'Password updated successfully'
    }
  },
  commonMenus: {
    title: 'Common menus',
    alias: 'Alias',
    messages: {
      update: 'Updated successfully'
    }
  },
  users: {
    title: 'Users',
    userTitle: 'User',
    name: 'Name',
    email: 'Email',
    client: 'Client',
    password: 'Password',
    repeatPassword: 'Repeat password',
    isSuperUser: 'Is superuser',
    enterprises: 'Web Apps',
    defaultEnterprise: 'Client by default',
    permissions: {
      title: 'Permissions',
      logs: 'Logs',
      stats: 'Stats',
      moveContent: 'Move content',
      cloneMenu: 'Clone menu',
      cloneEnterprise: 'Clone Web App',
      editDesktopMode: 'Edit desktop mode'
    },
    dishesMenu: 'Menu dishes administration',
    messages: {
      nameMostCharacters: 'Name must be at most 50 characters long',
      nameRequired: 'E-mail is required',
      emailValid: 'Must be valid e-mail',
      emailRequired: 'E-mail is required'
    }
  },
  enterprises: {
    title: 'Web Apps',
    enterpriseTitle: 'Client',
    name: 'Client',
    domain: 'Domain',
    privateBGColor: 'Admin private color',
    btnBackgroundColor: 'Content btn bgcolor',
    btnTextColor: 'Content btn textcolor',
    permissions: 'Permissions',
    dviewLink: 'Activities (Dview link)',
    dviewLinkShows: 'Shows (Dview link)',
    dviewLinkAgenda: 'Agenda (Dview link)',
    dviewLinkParrilla: 'Parrilla (Dview link)',
    dviewLinkCommercial: 'Commercial (Dview link)',
    dviewLinkProperty: 'Property (Dview link)',
    showMoscaDFeel: 'Show mosca DFeel',
    allergenFilters: 'Filtre à allergène',
    meteo: 'Meteo (zone)',
    linkCommon: 'Enlazar menús compartidos',
    clearStats: 'Reset stats',
    messages: {
      nameMostCharacters: 'Name must be at most 50 characters long',
      nameRequired: 'E-mail is required',
      domainMostCharacters: 'Domain must be at most 50 characters long',
      domainRequired: 'Domain is required'
    },
    backDomain: 'Btn back (domain)'
  },
  settings: {
    title: 'Settings',
    logoAndCarousel: {
      title: 'Logo and corousel',
      languages: 'Languages',
      logo: 'Logo',
      carousel: 'Carousel',
      messages: {
        update: 'Updated successfully'
      }
    },
    colors: {
      title: 'Colors',
      primary: 'Primary',
      secundary: 'Secundary',
      content: 'Content',
      backgroundColor: 'Background color',
      fontColor: 'Text color',
      fontSize: 'Font size',
      font: 'Font',
      shadow: 'Shadow',
      line: 'Line',
      messages: {
        update: 'Updated successfully'
      }
    },
    info: {
      recommendations: 'Recommendations',
      logo: {
        title: 'Logo',
        description: 'Minimum size and resolution of the recommended image 800x338px - 72ppp. PNG format with transparent background.'
      },
      carousel: {
        title: 'Carousel',
        description: 'Minimum size and resolution of the recommended image 1280x720px - 72ppp. PNG format with transparent background. Maximum three images.'
      },
      language: {
        title: 'Languages',
        description: 'Set the application languages. By default it is in Spanish. Remember that if you select several languages ​​you must place your translation. The application does not translate automatically.'
      }
    }
  },
  menus: {
    name: 'Menus',
    title: 'Settings',
    menuName: 'Menu name',
    submenuName: 'Submenu name',
    submenus: 'Submenus',
    isMenuTemp: 'Temp menu',
    isSubmenuTemp: 'Temp submenú',
    info: {
      noExistSubmenu: 'There are no submenus created',
      addMenu: 'You can start adding menus clicking on the next button',
      saveBeforeEdit: 'Save before editing new items',
      collapse: 'To order you must collapse the content',
      iconAndFunction: 'Iconography and general functions:',
      addContent: 'Add to menu',
      addToSubmenu: 'Add to submenu',
      moveContent: 'Move content',
      sortContent: 'Sort content',
      editContent: 'Edit content',
      language: 'Add translations',
      deleteContent: 'Delete content',
      cancel: 'Cancel content',
      menuWithoutContent: 'Menu or submenu without content',
      menuWithContent: 'Menu or submenu with content',
      saveContent: 'Save content',
      submenus: 'Meny con submenus',
      lockContent: 'External content not editable',
      finished: 'Temporary menu out of date',
      cloneContent: 'Clone content',
      hideContent: 'Hide content'
    },
    availability: {
      startDate: 'Start date',
      endDate: 'End date',
      noEndDate: 'No end date'
    },
    messages: {
      update: 'Updated successfully',
      delete: 'Deleted successfully'
    }
  },
  desktopMode: {
    title: 'Desktop view'
  },
  share: {
    title: 'Share',
    downloadSVG: 'Download SVG',
    downloadPNG: 'Download PNG',
    isPrivate: 'Private',
    addAccess: 'Create access',
    alias: 'Alias'
  },
  confirmDelete: {
    title: 'Do you want to remove this content?',
    message: 'This action cannot be reversed.'
  },
  confirmUndo: {
    title: 'Do you want cotinue?',
    message: 'Unsaved modifications will be deleted'
  },
  gallery: {
    maxInfo: 'Max 12 images'
  },
  map: {
    lat: 'Latitude',
    lon:'longitude'
  },
  twitter: {
    account: 'Account'
  },
  facebook: {
    account: 'Account'
  },
  activity: {
    type: 'Type',
    show: 'Spectacles',
    messages: {
      noActivities: 'No activities'
    }
  },
  timeline: {
    addEvent: 'Create event',
    title: 'Title',
    description: 'Description',
    hideHeader: 'Hide header'
  },
  contact: {
    addItem: 'Create item',
    description: 'Value',
    hideDivider: 'Hide divider',
    url: 'URL'
  },
  divider: {
    space: 'Space'
  },
  site: {
    title: 'Title',
    subtitle: 'Subtitle',
    address: 'Address',
    phone: 'Phone',
    web: 'Web',
    email: 'E-mail',
    moreInfo: 'More info',
    lat: 'Latitude',
    lon: 'Longitude',
    showMoreInfo: 'Show more info',
    hideMoreInfo: 'Hide info'
  },
  agenda: {
    showMoreInfo: 'Show more info'
  },
  wifi: {
    name: 'Name',
    ssid: 'SSID',
    password: 'Password',
    Authentication: 'Authentication',
    wep: 'WEP',
    wpa: 'WPA'
  },
  food: {
    name: 'Name',
    ingredients: 'Ingredients',
    price: 'Price',
    vegan: 'Vegan',
    vegetarian: 'Végétarien',
    spicy: 'Spicy',
    allergens: 'Allergènes',
    containsAllergens: 'Contient des allergènes'
  },
  linkDomain: {
    name: 'Name',
    domain: 'Subdomain'
  },
  form: {
    formDestinationMail: 'Courrier de destination',
    formRoomNumber: 'Nº chambre',
    formDateTime: 'Date et heure',
    formNumberOfPeople: 'Nº de personnes',
    name: 'Nom',
    formTextBtn: 'Button text',
    roomNum: 'Nº chambre',
    email: 'Email',
    phone: 'Téléphone',
    date: 'Date',
    time: 'Heure',
    numOfItems: 'Nº items',
    numOfPeople: 'Nº personnes',
    lblNumOfItems: 'Text number of items label',
    formLimitNumberOfItem: 'Limiter le nº items',
    observations: 'Remarques',
    messageSend: 'Message envoyé'
  },
  dishes: {
    title: 'Dishes',
    menu: 'Menu',
    food: 'Dishe',
    ingredients: 'Ingredients',
    price: 'Price',
    vegan: 'Vegan',
    vegetarian: 'Végétarien',
    allergens: 'Allergens',
    selectYourAllergy: 'Select your allergy',
    allergenFilter: 'Filtre à allergène',
    selectAllergens: 'Sélectionnez les allergènes pour éliminer les produits qui en contiennent',
    containsAllergens: 'Contient des allergènes'
  },
  menuTypes: {
    selectMenuType: 'Select the type of content to add',
    demo: 'Demo',
    activities: 'Activities',
    submenu: 'Submenu',
    simpleText: 'Simple text',
    space: 'Space',
    image: 'Image',
    iframe: 'Iframe',
    cardText: 'Alert',
    gallery: 'Gallery',
    video: 'Video',
    meteo: 'Meteo',
    map: 'Map',
    twitter: 'Twitter',
    facebook: 'Facebook',
    pdf: 'PDF',
    timeline: 'Timeline',
    text: 'Text',
    contact: 'Contact',
    divider: 'Line',
    shows: 'Shows',
    site: 'Site',
    agenda: 'Agenda',
    parrilla: 'Parrilla',
    wifi: 'Wifi',
    property: 'Property',
    commercial: 'Commercial',
    queue: 'Queue',
    food: 'Food/Drink',
    linkDomain: 'Link webapp',
    form: 'Form'
  },
  totem: {
    weatherForecast: 'Weather forecast',
    languageSelector: 'Language selector',
    accessibility: 'Accessibility',
    mobileVersion: 'Mobile version'
  },
  schedule: {
    startTime: 'Start time',
    interval: 'Interval'
  },
  availability: {
    isTemp: 'Temporary',
    periodicity: 'Periodicity',
    allDays: 'All days',
    oneDay: 'One day',
    recurrence: 'Recurrence',
    isAllTimes: 'All day',
    date: 'Date event',
    dateStart: 'Start date',
    dateEnd: 'End date',
    timeStart: 'Start time',
    timeEnd: 'End time',
    noEndDay: 'No end date',
    byWeek: 'By week',
    byMonth: 'By month',
    alternation: 'Alternation'
  },
  booking,
}

export default en
